import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./MobileOtpPage.css";
import { useDispatch } from "react-redux";
import FormInputStyle2 from "../../../../components/Form/FormInputStyle2";
import moment from "moment";
import { toast } from "react-toastify";
import callApi from "../../../../utility/apiCaller";
import { setUserClickData } from "../../../../utility/setUserClickData";
import {
  login,
  setAllOffers,
  setLead,
  setOffers,
} from "../../../../store/app/appReducer";
import OTPInput from "react-otp-input";
import _ from "lodash";
import {
  setAmountRequired,
  setAppId,
  setEmendateUrl,
  setInternalLead,
  setKfsUrl,
  setKycurl,
  setLeadId,
  setOpportunityId,
  setOpportunityName,
  setResponse,
  setUserData,
} from "../../../../store/app/aaSlice";
import useAddLead from "../../hooks/addLeadtoCRM";
import HeroSection from "../HeroSection/heroSection";

const MobileOtpPage = ({
  isFormStarted,
  setIsFormStarted,
  currentStep,
  setCurrentStep,
  formData,
  setFormData,
}) => {
  const [mobile, setMobile] = useState("");
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [source, setSource] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [utmMedium, setUtmMedium] = useState("");
  const [utmTerm, setUtmTerm] = useState("");
  const [affId, setAffId] = useState("");
  const [params] = useSearchParams();
  const [isConsentChecked, setIsConsentChecked] = useState(true);
  const [isTncChecked, setIsTncChecked] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [activeLenders, setActiveLenders] = useState([]);
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpTimerKey, setOtpTimerKey] = useState(0);
  const [isEditMobileModalOpen, setIsEditMobileModalOpen] = useState(false);
  const [editMobileValue, setEditMobileValue] = useState("");
  const [editMobileError, setEditMobileError] = useState("");
  const dispatch = useDispatch();
  const [leadId, setLeadId1] = useState("");
  const addLead = useAddLead();
  const RESEND_OTP_TIME = 30;
  const ldId = params.get("ld_id") || "";

  const [resendCounter, setResendCounter] = useState(RESEND_OTP_TIME);
  const [canResendOtp, setCanResendOtp] = useState(false);

  const [ipAddress, setIpAddress] = useState("");
  const [CuserName, setUserName] = useState("");
  const [CuserPhone, setUserPhone] = useState("");
  const [CuserLoanAmount, setUserLoanAmount] = useState("");

  async function fetchIp() {
    await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // ipAddress = data?.ip;
        setIpAddress(data?.ip);
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  }
  useEffect(() => {
    fetchIp();
  }, []);


  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const res = await fetch(
          `https://core-api.digitmoney.in/api/v1/preapproved_lead/${ldId}`
        );
  
        const data = await res.json();
        console.log("Full API response:", data);
  
        if (data?.data?.preapproved_lead?.contact_name) {
          setUserName(data.data.preapproved_lead.contact_name);
          setUserPhone(data.data.preapproved_lead.contact_phone);
          setUserLoanAmount(data.data.preapproved_lead.loan_amount === 0 ? 300000 : data.data.preapproved_lead.loan_amount );
        }
      } catch (err) {
        console.error("Error fetching preapproved lead:", err);
      }
    };
  
    fetchUserData();
  }, []);

 // Page load pe DB value fetch aur validation
useEffect(() => {
  if (CuserPhone) {
    setMobile(CuserPhone);
    setIsMobileValid(/^\d{10}$/.test(CuserPhone)); // automatic validation
  }
}, [CuserPhone]);

  useEffect(() => {
    if (!isOtpGenerated) return;

    setResendCounter(RESEND_OTP_TIME);
    setCanResendOtp(false);

    const interval = setInterval(() => {
      setResendCounter((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setCanResendOtp(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isOtpGenerated, otpTimerKey]);


  useEffect(() => {
    if (params.get("source")) setSource(params.get("source"));
    if (params.get("utm_source")) setUtmSource(params.get("utm_source"));
    if (params.get("utm_medium")) setUtmMedium(params.get("utm_medium"));
    if (params.get("utm_term")) setUtmTerm(params.get("utm_term"));
    if (params.get("aff_id")) setAffId(params.get("aff_id"));
    if (params.get("lid")) setLeadId1(params.get("lid"));
  }, [params]);

  useEffect(() => {
    const container = document.getElementById("personal-loan-form");
    if (container)
      container.resetOtpState = () => {
        setIsOtpGenerated(false);
        setOtp("");
      };
  }, []);

  useEffect(() => {
    const fetchActiveLenders = async () => {
      try {
        const res = await callApi(
          `v1/lender/active-lenders`,
          "get",
          {},
          "loan"
        );
        if (res.status === "Success") {
          const apiLenders = res.data.lenderList ?? [];

          const hardcodedLender = {
            _id: "68ad8ed5078abf6c677e4303",
            lender_name: "DMI",
          };

          const mergedLenders = [...apiLenders, hardcodedLender];

          setActiveLenders(mergedLenders);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchActiveLenders();
  }, []);

  const fetchOffers = async (leadId, token) => {
    if (!leadId) return false;
    const momentDate = moment("2025-12-09")
      .utcOffset(330)
      .startOf("day")
      .toISOString();

    try {
      // STEP 1: Fetch base offers
      const res = await callApi(
        `v1/loan_offer/list`,
        "post",
        {
          filters: {
            alliance_id: "website-pl-ete-new-lead",
            created_at: {
              $gte: momentDate,
            },
            lead_id: leadId,
          },
        },
        "core",
        token
      );

      if (
        !(
          res.status === "Success" &&
          Array.isArray(res.data?.loan_offerList) &&
          res.data.loan_offerList.length > 0
        )
      ) {
        return { success: false, offers: [] };
      }

      const offers = res.data.loan_offerList;
      // STEP 2: Fetch lender success/fail list
      const lenderListRes = await callApi(
        `v1/lender_api_call/${leadId}/get-fail-success-lenders`,
        "post",
        {},
        "loan",
        token
      );

      let lenderMap = {};

      const failedList = lenderListRes.data?.FailList || [];

      if (
        lenderListRes.status === "Success" &&
        Array.isArray(lenderListRes.data?.Successlist)
      ) {
        lenderMap = Object.fromEntries(
          lenderListRes.data.Successlist.map((lender) => [
            lender.lender_id,
            lender,
          ])
        );
      }

      // STEP 3: Enrich base offers using success lenders
      const enrichedOffers = offers.map((offer) => {
        const lender = lenderMap[offer.lender_id] || {};

        return {
          ...offer,
          apr: lender.apr ?? "",
          kfs_doc: lender.kfs_doc ?? "",
          credit_limit: lender.web_offer ?? "",
          penal_charges: lender.penal_charges ?? "",
          processing_fee: lender.processing_fee ?? "",
          interest_rate: lender.web_interest ?? null,
          lender_name: lender.lender_name ?? offer.lender_name,
        };
      });

      // STEP 4: Sort by priority
      const sortedOffers = _.orderBy(enrichedOffers, ["priority"], ["asc"]);

      // STEP 5: Filter by active lenders if present
      const filteredOffers = activeLenders.length
        ? sortedOffers.filter((offer) =>
          activeLenders.some((lender) => lender._id === offer.lender_id)
        )
        : sortedOffers;

      return {
        success: true,
        offers: filteredOffers,
        failedList: failedList,
      };
    } catch (err) {
      console.error("Error in offer fetching", err);
      toast.error("Something went wrong while fetching offers.");
      return { success: false, offers: [] };
    }
  };

  const generateLead = async (token) => {
    try {
      // -----------------------------
      // 1️⃣ CREATE LEAD (DMI LEAD API)
      // -----------------------------
      const res = await callApi(
        "v1/lead/dmi-lead",
        "post",
        {
          lead: {
            contact_phone: mobile,
            contact_name: "N/A",
            steps_completed: 1,
            alliance_id: "website-pl-e2eFeb-lead",
            aff_id: params.get("aff_id") || null,
            utm_source: params.get("utm_source") || null,
            source: params.get("source") || null,
            utm_medium: params.get("utm_medium") || null,
            utm_term: params.get("utm_term") || null,
            ads_name: params.get("ads_name") || null,
            ip_address: ipAddress,
            kyc_consent: isTncChecked,
            kyc_consent_datetime: new Date().toISOString(),
          },
        },
        "core",
        token
      );

      // -----------------------------
      // 2️⃣ VALIDATE RESPONSE
      // -----------------------------
      if (!res || res.status !== "Success") {
        console.error("DMI Lead API failed:", res);
        toast.error("Unable to create lead at the moment.");
        return false;
      }

      const finalLeadId = res?.data?.lead?._id;

      if (!finalLeadId) {
        console.error("Lead ID missing in response:", res);
        toast.error("Lead creation failed due to invalid response.");
        return false;
      }

      // -----------------------------
      // 3️⃣ STORE INTERNAL LEAD ID
      // -----------------------------
      dispatch(setInternalLead(finalLeadId));

      // -----------------------------
      // 4️⃣ ADD LEAD TO CRM SYSTEM
      // -----------------------------
      try {
        await addLead({
          leadId: finalLeadId,
          lead_type: "live",
          priority: 4,
          stage: "OTP",
        });
      } catch (crmError) {
        console.error("Error adding lead to CRM:", crmError);
        // optionally show toast but not required
      }

      return finalLeadId; // useful if caller needs it
    } catch (error) {
      // -----------------------------
      // 5️⃣ GLOBAL ERROR CATCH
      // -----------------------------
      console.error("Unexpected error in generateLead:", error);
      toast.error("Something went wrong while generating lead.");
      return false;
    }
  };

  // useEffect(() => {
  //   const fetchLeadData = async () => {
  //     try {
  //       if (leadId) return;

  //       const response = await callApi(
  //         "v1/lead/list",
  //         "post",
  //         {
  //           filters: { _id: lid },
  //         },
  //         "core" // specify the core service here
  //       );

  //       const lead = response?.data?.leadList?.[0];
  //       console.log(lead); // assuming API returns array of leads

  //       if (lead) {
  //         setMobile(lead?.contact_phone || "");

  //         // Update the overall formData too
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch lead data:", error);
  //     }
  //   };

  //   fetchLeadData();
  // }, [setFormData]);

  const handleMobileChange = (event) => {
    const value = event.target.value;

    if (/^\d*$/.test(value)) {
      setMobile(value);
      setFormData((prev) => ({
        ...prev,
        mobile: value,
      }));
    }

    setIsMobileValid(value.length === 10);
  };

  const handleConsentChange = () => {
    setIsConsentChecked((prev) => !prev);
  };

  const handleValidation = () => {
    let isValid = true;

    // if (!mobile || mobile.trim() === "") {
    //   isValid = false;
    //   setIsMobileValid(false);
    // }
    if (!/^\d{10}$/.test(mobile) || mobile.length !== 10) {
      isValid = false;
      setIsMobileValid(false);
    } else {
      setIsMobileValid(true);
    }

    return isValid;
  };

  const handleSendOtp = async () => {
    if (!handleValidation()) {
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
        },
        "messaging"
      );
      if (response.status === "Success") {
        setUserClickData({
          event_name: `otp-send-for-e2eFeb`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium,
          utm_term: utmTerm,
        });
        setFormData((prev) => ({
          ...prev,
          mobile,
          mobiletncchecked: true,
          mobiletnctime: new Date().toISOString(),
          stepDone: 3,
        }));
        toast.success("OTP Sent Successfully");
        setIsOtpGenerated(true);
        setIsFormStarted(true);
        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (!canResendOtp) return;

    try {
      setIsLoading(true);

      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: mobile,
          kyc_consent: isConsentChecked,
          kyc_consent_datetime: new Date().toISOString(),
        },
        "messaging"
      );

      if (response.status === "Success") {
        setUserClickData({
          event_name: `resend-otp-form-for-e2eFeb`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium,
          utm_term: utmTerm,
        });

        toast.success("OTP Resent Successfully");

        setOtpTimerKey((prev) => prev + 1);
      } else {
        toast.error("Failed to resend OTP.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while resending OTP.");
    } finally {
      setIsLoading(false);
    }
  };


  const fetchLeadData = async (token) => {
    try {
      if (leadId) return { hasLead: false, hasOffer: false };

      const startDate = moment()
        .subtract(1, "months")
        .startOf("day")
        .toISOString();
      const endDate = moment().endOf("day").toISOString();

      const response = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: {
            contact_phone: mobile,
            created_at: {
              $gte: startDate,
              $lte: endDate,
            },
          },
        },
        "core"
      );

      const sortedLeads = (response?.data?.leadList || []).sort(
        (a, b) =>
          new Date(b.updatedAt || b.createdAt) -
          new Date(a.updatedAt || a.createdAt)
      );

      const lead = sortedLeads[0];
      let hasLead = false;
      let hasOffer = false;
      let currentLeadId = null;

      if (lead) {
        const { _id, steps_completed } = lead;
        console.log(_id, steps_completed);
        hasLead = true;
        currentLeadId = _id;

        if (steps_completed > 3) {
          console.log("lead: ", lead);
          const {
            _id = "",
            steps_completed = 0,
            application_id = "",
            dmi_lead_response_id = "",
            dmi_lead_id = "",
            dmi_opportunityid = "",
            amount_required,
            kycurl = "",
            emandateurl = "",
            dmi_opportunityName = "",
            dmi_offers_details,
          } = lead;

          let startStep = 1;

          // 🔑 update redux
          console.log({
            setInternalLead,
            setResponse,
            setAppId,
            setLeadId,
            setOpportunityId,
            setKycurl,
            setAmountRequired,
            setKfsUrl,
            setUserData,
            setEmendateUrl,
            setOpportunityName,
            setOffers,
          });

          dispatch(setInternalLead(_id));
          dispatch(setResponse(dmi_lead_response_id));
          dispatch(setAppId(application_id));
          dispatch(setLeadId(dmi_lead_id));
          // dispatch(setOffers(dmi_offer));
          dispatch(setOpportunityId(dmi_opportunityid));
          dispatch(setKycurl(kycurl));
          dispatch(setAmountRequired(amount_required));
          dispatch(setKfsUrl(lead.kfsurl));
          dispatch(setUserData(lead));
          dispatch(setEmendateUrl(emandateurl));
          dispatch(setOpportunityName(dmi_opportunityName));
          dispatch(setOffers(dmi_offers_details));

          // Check if there are offers
          hasOffer = !!(
            dmi_offers_details &&
            (Array.isArray(dmi_offers_details)
              ? dmi_offers_details.length > 0
              : Object.keys(dmi_offers_details).length > 0)
          );

          // 🔑 decide correct starting step
          if (!steps_completed || steps_completed === 0) {
            setCurrentStep(1);
          }
          if (steps_completed >= 3 && steps_completed <= 16) {
            startStep = steps_completed + 1;
          }

          setCurrentStep(startStep);
        } else {
          dispatch(setLead({ id: _id }));
          dispatch(setInternalLead(_id));
          setFormData((prev) => ({
            ...prev,
            name: lead.contact_name || "",
            mobile: lead.contact_phone || "",
            email: lead.contact_email || "",
            gender: lead.gender || "",
            pancard: lead.pancard || "",
            pincode: lead.pincode || "",
            professionType: lead.profession_type || "",
            dob: moment(lead?.dob).format("YYYY-MM-DD"),
            company_name: lead?.company_name,
            company_type: lead?.company_type,
            work_contact_email: lead?.work_contact_email,
            loan_purpose: lead?.loan_purpose,
            monthly_income: lead?.monthly_income,
            alliance_id: lead?.alliance_id,
          }));
          const offer = await fetchOffers(_id, token);
          if (offer?.success && offer?.offers?.length > 0) {
            hasOffer = true;
            dispatch(
              setAllOffers({
                offers: offer.offers,
                failedList: offer.failedList,
              })
            );
          } else {
            setCurrentStep((prev) => prev + 1);
          }
          // haveOffer ? setCurrentStep(3) : setCurrentStep((prev) => prev + 1);
        }
      } else {
        // No lead found, start from step 2
        generateLead(token);
        setCurrentStep((prev) => prev + 1);
      }
      console.log("Fetched Lead:", lead);
      console.log("going to stpe ", currentStep);
      return { hasLead, hasOffer, leadId: currentLeadId };
    } catch (error) {
      console.error("Failed to fetch lead data:", error);
      return { hasLead: false, hasOffer: false, leadId: null };
    }
  };

  const handleOtpSubmit = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter a valid 4-digit OTP.");
      return;
    }

    // if (!isConsentChecked) {
    //   toast.error("Please agree to the Terms and Conditions.");
    //   return;
    // }

    try {
      setIsLoading(true);
      const otpResponse = await callApi(
        "v1/sms/validate-otp",
        "post",
        {
          contact_phone: mobile,
          otp,
        },
        "messaging"
      );

      if (otpResponse.status === "Success") {
        setUserClickData({
          event_name: `otp-submit-for-e2eFeb`,
          user_id: mobile || "unknown",
          affiliate_id: affId || "No Aff_id found",
          utm_source: utmSource || utmMedium || "",
          utm_term: utmTerm,
        });
        toast.success("OTP Verified Successfully");
        const leadData = await fetchLeadData(otpResponse?.data.token);
        console.log("leadData: ", leadData);

        dispatch(
          login({
            ...otpResponse.data.customer,
            token: otpResponse.data.token,
          })
        );
        localStorage.setItem("mobile", mobile);

        // Call useAddLead hook twice if there is lead and offer
        if (leadData?.hasOffer && leadData?.leadId) {
          try {
            // Second call for offer
            await addLead({
              leadId: leadData.leadId,
              lead_type: "live",
              priority: 2,
              stage: "Have offer",
            });
            setCurrentStep(6);
          } catch (error) {
            console.error("Error adding offer to CRM:", error);
          }
        }
        // const leadResponse = await callApi(
        //   "v1/lead/lead-from-phone",
        //   "post",
        //   {
        //     phone: mobile,
        //     website_kyc_consent: isTncChecked,
        //     website_kyc_consent_datetime: new Date().toISOString(),
        //     utm_source: utmSource || utmMedium,
        //     otp_page: "offer-check-v1",
        //     ip_address: ipAddress,
        //   },
        //   "core",
        //   otpResponse.data.token
        // );

        // const leadId = leadResponse?.data?.lead?._id;
        // if (leadId) {
        //   try {
        //     await fetch(
        //       "https://campaigns.digitmoney.in/api/offercheck/requestjson.php?case=insert_digit_money_data",
        //       {
        //         method: "POST",
        //         headers: {
        //           "Content-Type": "application/json",
        //         },
        //         body: JSON.stringify({
        //           api_key: "fca6416db1074658d6b6823380d18f04",
        //           mobile: mobile,
        //           lead_id: leadId,
        //         }),
        //       }
        //     );
        //   } catch (e) {
        //     console.error("Error in external lead insert:", e);
        //   }
        // }
      } else {
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (otpError) {
      console.error("Error occurred while verifying OTP:", otpError);
      toast.error("An error occurred while verifying OTP. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const openEditMobileModal = () => {
    setEditMobileValue(mobile || "");
    setEditMobileError("");
    setIsEditMobileModalOpen(true);
  };

  const closeEditMobileModal = () => {
    setIsEditMobileModalOpen(false);
    setEditMobileError("");
  };

  const handleEditMobileSendOtp = async () => {
    const nextMobile = String(editMobileValue || "").trim();
    if (!/^\d{10}$/.test(nextMobile)) {
      setEditMobileError("Please enter a valid Mobile Number");
      return;
    }

    try {
      setIsLoading(true);
      const response = await callApi(
        "v1/sms/send-otp",
        "post",
        {
          contact_phone: nextMobile,
          kyc_consent: isConsentChecked,
        },
        "messaging"
      );

      if (response.status === "Success") {
        setMobile(nextMobile);
        setFormData((prev) => ({
          ...prev,
          mobile: nextMobile,
        }));
        setOtp("");
        setIsOtpGenerated(true);
        setOtpTimerKey((prev) => prev + 1);
        closeEditMobileModal();
        toast.success("OTP Sent Successfully");
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred while sending OTP.");
    } finally {
      setIsLoading(false);
    }
  };

  const formatResendTime = (seconds) => {
    const clamped = Math.max(0, Number(seconds) || 0);
    const mm = String(Math.floor(clamped / 60)).padStart(2, "0");
    const ss = String(clamped % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };


  const P = CuserLoanAmount; 
  const annualRate = 18;
  const n = 24;

  const r = annualRate / 12 / 100;

  const EMI =
    (P * r * Math.pow(1 + r, n)) /
    (Math.pow(1 + r, n) - 1);

  return (
    <>
      {!isOtpGenerated ? (
        <>
          <HeroSection CuserName={CuserName} CuserPhone={CuserName} CuserLoanAmount={CuserName}
            userName={String(formData?.name || params.get("ads_name") || "").trim()}
            onContinue={() => {
              const mobileInput = document.getElementById("mobile");
              if (mobileInput && typeof mobileInput.focus === "function")
                mobileInput.focus();

              const container = document.getElementById("personal-loan-form");
              if (container && typeof container.scrollIntoView === "function") {
                container.scrollIntoView({ behavior: "smooth", block: "start" });
              }
            }}
          />
          <div className="lead-capture-container1">
            {/* <div className="relative flex items-center my-6 px-2">
              <div className="flex-grow border-t border-gray-300"></div>
              <span className="mx-2 text-sm font-medium text-gray-500 whitespace-nowrap">
                Check your loan eligibility instantly
              </span>
              <div className="flex-grow border-t border-gray-300"></div>
            </div> */}



            <div
        className='w-full rounded-2xl p-[1px] plv16-preapproved-border'
        style={{
          backgroundImage:
            "linear-gradient(104.79deg, rgba(77, 97, 102, 0.8) 15.49%, #CADDE1 44.57%, rgba(76, 91, 95, 0.2) 73.66%)",
        }}
      >
        <div className='rounded-[15px] p-4 plv16-preapproved-card' style={{
          border: "1px solid",
          backgroundColor: "#F5F5F5",
          borderImageSource: "linear-gradient(104.79deg, rgba(77, 97, 102, 0.8) 15.49%, #CADDE1 44.57%, rgba(76, 91, 95, 0.2) 73.66%)",
        }}>
          <div className='flex items-start justify-center plv16-preapproved-cols'>
            <div className='w-[155px] mr-4 flex-shrink-0 plv16-preapproved-left'>
              <span
                className='text-[13px] leading-[14px] mb-[10px] text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Your pre-approved loan amount
              </span>
              <div
                className='text-[30px] font-bold mb-0 text-black'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                ₹{Number(CuserLoanAmount).toLocaleString("en-IN")}
              </div>
            </div>
            <div className='w-px h-[73px] bg-gray-200 self-stretch my-auto plv16-preapproved-divider' style={{
              border: "1px solid",
              borderImageSource: "linear-gradient(90deg, rgba(68, 86, 90, 0) 0%, #C8DBDF 50%, rgba(68, 86, 90, 0) 100%)",
            }}>
            </div>
            <div className='w-[100px] ml-4 flex-shrink-0 plv16-preapproved-right'>
              <span
                className='text-[13px] leading-[14px] mb-[10px] text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Your monthly EMI is 
              </span>
              <div
                className='text-[22px] font-bold mb-0 text-black'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                ₹{Math.round(EMI).toLocaleString("en-IN")}
              </div>
            </div>
          </div>

          <div
            className='w-100 h-[60px] rounded-[15px] p-[1px] mt-[30px] mx-auto plv16-hero-cta-border'
            style={{
              backgroundImage:
                "linear-gradient(267.34deg, #00A953 1.33%, #009F4E 46.82%, #75FFB9 92.32%)",
            }}
          >

            <input type="hidden" name="utm_campaign" value="" />
            <input type="hidden" name="utm_source" value={utmSource || ""} />
            <input type="hidden" name="utm_medium" value="" />
            <input type="hidden" name="utm_content" value="" />
            <input type="hidden" name="click_id" value="" />
            <input type="hidden" name="aff_id" value={affId || ""} />
            <input type="hidden" name="src" value={source || ""} />

              <button
              type="button"
              className="plv16-otp-btn"
              onClick={handleSendOtp}
              disabled={!isMobileValid || isLoading}
              id="btn-get-otp-landing-v9"
            >
              {isLoading ? "Processing..." : "Continue to Unlock My Loan"}
            </button>
          </div>

          <div className='flex items-center justify-center gap-6 mt-3 plv16-hero-benefits'>
            <div className='flex items-center gap-2'>
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.72222 0.500031L0.5 8.90003H7L6.27778 14.5L13.5 6.10003H7L7.72222 0.500031Z" fill="white" stroke="#2A3A3F" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <span
                className='text-[13px] leading-[18px] text-center text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Takes ~5 minutes
              </span>
            </div>
            <div className='flex items-center gap-2'>
              <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.5H7.38867C7.53692 0.5 7.67747 0.565897 7.77246 0.679688L11.6064 5.28027C11.6812 5.3701 11.7227 5.4837 11.7227 5.60059V14.7139C11.7227 14.9899 11.4986 15.2136 11.2227 15.2139H1C0.723858 15.2139 0.5 14.99 0.5 14.7139V1C0.5 0.723858 0.723857 0.5 1 0.5Z" fill="white" stroke="#2A3A3F" stroke-linecap="round" />
                <path d="M7.85718 0.873016V4.2381C7.85718 4.79038 8.30489 5.2381 8.85718 5.2381H11.3492" stroke="#2A3A3F" stroke-linecap="round" />
                <path d="M9 8.00003L3 8M5.57143 10L3 10" stroke="#2A3A3F" stroke-linecap="round" />
              </svg>

              <span
                className='text-[13px] leading-[18px] text-center text-black font-normal'
                style={{
                  fontFamily:
                    "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
                }}
              >
                Zero paperwork
              </span>
            </div>
          </div>
        </div>
      </div>
<br />
            
            {/* <FormInputStyle2
              type="text"
              name="mobile"
              isValid={isMobileValid}
              id="mobile"
              minLength="10"
              maxLength="10"
              pattern="[0-9]{10}"
              value={mobile}
              onChange={handleMobileChange}
              required
              label={"Mobile Number"}
              inputMode="numeric"
              errorMessage={"Please enter a valid Mobile Number"}
            /> */}

          
          </div>
        </>
      ) : (
        <div className="plv16-otp-page">
          <div className="plv16-otp-hero">
            <img
              src="/assets/img/Layer_1 (47).png"
              className="plv16-otp-lock"
              alt="Lock"
            />

            <h1 className="plv16-otp-title">Verify number securely</h1>

            <p className="plv16-otp-subtitle">
              Your details are safe with us
              <img
                src="/assets/img/Layer_1 (48).png"
                className="plv16-otp-info"
                alt="Secure"
              />
            </p>
          </div>

          <div className="plv16-otp-card">
            <div className="plv16-otp-card-title">
              We can help prefill your information
            </div>

            <div className="plv16-otp-card-subtitle">
              Enter OTP sent to{" "}
              <span className="plv16-otp-phone">
                +91-{mobile || "98198 79393"}
              </span>{" "}
              <button
                type="button"
                className="plv16-otp-edit"
                onClick={openEditMobileModal}
              >
                Edit
              </button>
            </div>

            <div className="plv16-otp-input-wrap">
              <OTPInput
                value={otp}
                onChange={(val) => setOtp(val)}
                numInputs={4}
                isInputNum={true}
                shouldAutoFocus={true}
                inputStyle="plv16-otp-input"
                containerStyle="plv16-otp-inputs"
                placeholder={"----"}
                renderInput={(props) => <input {...props} />}
              />
            </div>

            <div className="plv16-otp-consent-row">
              <input
                type="checkbox"
                id="plv16-otp-consent"
                checked={isConsentChecked}
                onChange={handleConsentChange}
              />
              <label
                htmlFor="plv16-otp-consent"
                className="plv16-otp-consent-text"
              >
                I have read and agreed to the{" "}
                <a href="https://digitmoney.in/terms">Terms of Use</a> and
                hereby appoint DigitMoney and its{" "}
                <a href="https://digitmoney.in/lenders">Lending Partners</a>{" "}
                to receive my credit information from credit bureaus. By
                submitting my details I override my NDNC registration and
                authorize DigitMoney and its Lending Partners to contact me.
              </label>
            </div>
          </div>

          <div className="plv16-otp-footer">
            <div className="plv16-otp-resend">
              {canResendOtp ? (
                <button
                  type="button"
                  className="plv16-otp-resend-link"
                  onClick={handleResendOtp}
                  disabled={isLoading}
                >
                  Resend OTP
                </button>
              ) : (
                <>Resend OTP in <span>{formatResendTime(resendCounter)}</span></>
              )}
            </div>

            <button
              type="button"
              className="plv16-otp-btn"
              onClick={handleOtpSubmit}
              disabled={otp.length !== 4 || isLoading}
              id="btn-verify-otp-personal-details-v9"
            >
              {isLoading ? "Processing..." : "Verify OTP"}
            </button>
          </div>

          {isEditMobileModalOpen ? (
            <div
              className="plv16-otp-modal-overlay"
              role="dialog"
              aria-modal="true"
              onClick={closeEditMobileModal}
            >
              <div
                className="plv16-otp-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="plv16-otp-modal-header">
                  <button
                    type="button"
                    className="plv16-otp-modal-close"
                    onClick={closeEditMobileModal}
                    aria-label="Close"
                  >
                    ×
                  </button>
                </div>
                <div className="plv16-otp-modal-title">Edit Mobile Number</div>
                <div className="plv16-otp-modal-subtitle">
                  We'll send an new OTP to this number.
                </div>

                <div className="plv16-otp-modal-body">
                  <input
                    type="tel"
                    inputMode="numeric"
                    placeholder="Enter New Mobile Number"
                    className="plv16-otp-modal-input"
                    value={editMobileValue}
                    onChange={(e) => {
                      const next = e.target.value.replace(/\D/g, "").slice(0, 10);
                      setEditMobileValue(next);
                      setEditMobileError("");
                    }}
                  />
                  {editMobileError ? (
                    <div className="plv16-otp-modal-error">
                      {editMobileError}
                    </div>
                  ) : null}

                  <button
                    type="button"
                    className="plv16-otp-modal-btn"
                    onClick={handleEditMobileSendOtp}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Send OTP"}
                  </button>

                  <div className="plv16-otp-modal-footnote">
                    Make sure this number is active to receive the OTP.
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default MobileOtpPage;
